import React, { useState, useEffect } from 'react'
import { Row, Form, Button, Col } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import { toast } from 'react-toastify';
import { useGetPublicsubjectQuery } from '../../slices/teachers/subjectApiSlice';
import { useCreateCourseMutation } from '../../slices/teachers/courseApiSlice';
import TeacherHeader from '../../components/TeacherHeader';
import TeacherNavbar from '../../components/TeacherNavbar';
import Loader from '../../components/Loader';
import Message from '../../components/Message';

const TeacherNewCourse = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { id } = useParams();


    const [loading, setLoading] = useState(false); 
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [teachername, setTeacherName] = useState('');

 
    const { data, error, isLoading } = useGetPublicsubjectQuery(id);

    console.log(data)

    const [createCourse, { isLoading: courseLoading, error: courseError }] = useCreateCourseMutation();


    const { teacherInfo } = useSelector((state) => state.authTeacher);

    useEffect(() => {
        setTitle(data?.tittle);
        setDescription(data?.description);
        setTeacherName(teacherInfo.firstname + ' ' + teacherInfo.lastname);
    }, [data]);


    const submitHandler = async (e) => {
        e.preventDefault()
        try {
            const res = await createCourse({
                title,
                description,
                id,
                teachername
            }).unwrap();
        } catch (err) {
            toast.error(err?.data?.message || err.error.message);
        }
    };

    return (
    <div>
        <TeacherNavbar />
        <div className="main-content" id="panel">
        <TeacherHeader />
        <br /><br /><br /><br /><br />
            <div className="container-fluid mt--6">
                <div className="row">
                <div className="col-xl-8 offset-xl-2 ">  
                        <div className="card-wrapper">
                            <div className="card ">
                                <div className=""><br /><br />
                                    <h1 className="mb-0 centerTitle  tittleColor4">
                                    <span className='tittleColor4'>Create  new Course
                                        </span>
                                        </h1><br /><br />
                                </div>
                                { loading ? ( 
                                        <Loader />
                                    ) : error ? (
                                        <Message variant='danger'>
                                            {error?.data?.message || error.error}
                                        </Message>
                                    ) : (                                
                                <div className="card-body">
                                    <Form onSubmit={submitHandler}>
                                        <div className="form-group">
                                            <div className="input-group input-group-merge input-group-alternative mb-3">
                                                <div className="input-group-prepend moveInput">
                                                <span className="input-group-text bg-gradient-info"><i className="ni ni-tag navText"></i></span>
                                                </div>
                                                <input 
                                                    className="form-control emailForm" 
                                                    placeholder="Title" 
                                                    type="text" 
                                                    value={title}
                                                    onChange={(e) => setTitle(e.target.value)}   
                                                                                                                        
                                                />
                                            </div>
                                        </div><br />

                                        <div className="form-group">
                                                    <h6 className="" placeholder="  Plan Name" type="text">Description:</h6>   
                                                    <div className="input-group input-group-merge input-group-alternative mb-3">
                                                        <div className="input-group-prepend moveInput">
                                                        <span className="input-group-text bg-gradient-warning"><i className="ni ni-archive-2 navText"></i></span>
                                                        </div>
                                                        <textarea 
                                                            className="form-control emailForm" 
                                                            placeholder="  Description" 
                                                            rows="3"
                                                            value={description}
                                                            onChange={(e) => setDescription(e.target.value)}                                          
                                                        />
                                                    </div>
                                                </div><br />
                                       

                                        


                                        <div className='mycard'><br /><br /><br /><br />
                                            <Button  type='submit' variant="primary rounded-pill bg-gradient-info btn-lg "> 
                                                Create Course  
                                            </Button>
                                        </div>
                                    </Form>
                                </div>
                            )} 

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    )
}

export default TeacherNewCourse
